// extracted by mini-css-extract-plugin
export var firstRow = "three-blocks-and-image-module--first-row--7bd90";
export var image = "three-blocks-and-image-module--image--89a43";
export var threeBlocksAndImage = "three-blocks-and-image-module--threeBlocksAndImage--aae67";